/* ValueBuilder.js */

"use strict";

const _ = require("lodash");

class ValueBuilder {
    /**
     * Get an instance value based on the default values of the JType.
     *
     * @param cs - The expanded notation of the jtype
     * @param valueObj - The value object to populate.
     */
    static getJTypeInstanceData(cs, valueObj) {
        ValueBuilder._traverseObj(cs, valueObj);
    }

    static _traverseObj(curObj, destObj) {
        let curObjPropOrder = curObj["@propertyOrder"];
        if (!curObjPropOrder) {
            curObjPropOrder = Object.keys(curObj);
        }
        for (let i = 0; i < curObjPropOrder.length; i++) {
            let prop = curObjPropOrder[i];
            let curExObj = curObj[prop];
            ValueBuilder._traverseExObj(curExObj, destObj, prop);
        }
    }

    static _traverseExObj(curExObj, destObj, prop) {
        if (typeof curExObj === "object" && curExObj["@"] === "@") {
            let typeValue = typeof curExObj.value;
            if (curExObj.fieldType === "Regex") {
                let regexSeedValue = curExObj.Regex;
                let regexDefaultValue = _.get(curExObj, "value", null);
                let value = {regex: null, testString: null};

                if (_.isString(regexSeedValue)) {
                    value.regex = regexSeedValue;
                } else if (!_.isEmpty(regexSeedValue)) {
                    value.regex = _.get(regexSeedValue, "regex", null);
                    value.testString = _.get(regexSeedValue, "testString", null);
                }

                if (_.isString(regexDefaultValue)) {
                    value.regex = regexDefaultValue;
                } else if (!_.isEmpty(regexDefaultValue)) {
                    value.regex = regexDefaultValue.hasOwnProperty("regex")
                        ? value.regex
                        : regexSeedValue.regex;
                    value.testString = regexDefaultValue.hasOwnProperty("testString")
                        ? value.testString
                        : regexSeedValue.testString;
                }
                destObj[prop] = value;
            } else if (typeValue === "object") {
                if (curExObj.value === null) {
                    destObj[prop] = null;
                } else if (Array.isArray(curExObj.value)) {
                    destObj[prop] = [];
                    for (let i = 0; i < curExObj.value.length; i++) {
                        let arrayVal = curExObj.value[i];
                        if (typeof arrayVal === "object") {
                            if (arrayVal.fieldType === "String" && _.has(arrayVal, "value")) {
                                destObj[prop].push(arrayVal.value);
                            }
                            continue;
                        }
                        ValueBuilder._traverseExObj(arrayVal, destObj[prop], i);
                    }
                } else {
                    //Normal object
                    destObj[prop] = {};
                    ValueBuilder._traverseObj(curExObj.value, destObj[prop]);
                }
            } else if (typeValue === "undefined") {
                if (curExObj.TypeDef) {
                    //TypeDef properties are not displayed.
                    return;
                }
                if (curExObj.fieldType) {
                    if (curExObj.fieldType === "Choice") {
                        return;
                    }
                    if (curExObj.fieldType === "Ref") {
                        if (_.get(curExObj, "Ref.many", false)) {
                            destObj[prop] = {
                                "@ref": {
                                    instances: [],
                                },
                            };
                        } else {
                            destObj[prop] = {"@ref": null};
                        }
                        return;
                    }
                }
                destObj[prop] = null;
            } else if (typeValue === "string") {
                if (curExObj.fieldType) {
                    if (curExObj.fieldType === "Ref") {
                        destObj[prop] = {"@ref": curExObj.value};
                        return;
                    }
                    if (
                        curExObj.fieldType === "Select" &&
                        curExObj.Select &&
                        curExObj.Select.options
                    ) {
                        destObj[prop] = curExObj.value;
                        //This is a seeded select value so add that select option to the object.
                        let option = curExObj.Select.options[curExObj.value];
                        if (option && option["@"] === "@" && option.value) {
                            ValueBuilder._traverseObj(option.value, destObj);
                        }
                        return;
                    }
                    if (
                        curExObj.fieldType === "Choice" &&
                        curExObj.Choice &&
                        curExObj.Choice.options
                    ) {
                        //This is a seeded select value so add that select option to the object.
                        let option = curExObj.Choice.options[curExObj.value];
                        if (option && option["@"] === "@") {
                            ValueBuilder._traverseExObj(option, destObj, curExObj.value);
                        }
                        return;
                    }
                }
                destObj[prop] = curExObj.value;
            } else {
                destObj[prop] = curExObj.value;
            }
        }
    }
}

module.exports = ValueBuilder;
